import { call, take, put } from 'redux-saga/effects';
import { get, deleteMethod, putMethod } from '../../utils/api';
import { getToken, getBelongsTo } from '../../utils/helper';
import settings from '../../utils/settings';
import {
  YELP_REQUEST,
  YELP_SUCCESS,
  YELP_FAILURE,
  SATE_LIST_REQUEST,
  SATE_LIST_SUCCESS,
  SATE_LIST_FAILURE,
  COMPANY_LIST_REQUEST,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAILURE,
  GOOGLE_REVIEW_REQUEST,
  GOOGLE_REVIEW_SUCCESS,
  GOOGLE_REVIEW_FAILURE,
  DELETE_COMPANY_LOGO_REQUEST,
  UPDATE_COMPANY_LOGO_REQUEST,
  UPDATE_RATING_REQUEST,
  UPDATE_RATING_SUCCESS,
  UPDATE_RATING_FAILURE
} from './constants';
import { UPDATE_ACCOUNT_MANAGER_SUCCESS } from '../Layouts/constants';
import { get as lodashGet, isEqual as lodashIsEqual } from '../../utils/lodash';

export function* yelpLinkFlow() {
  while (true) {
    const request = yield take(YELP_REQUEST);
    try {
      let response;
      const { payload, successCbk = () => { }, isUpdate = false } = request;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/yelp_info/${payload}`)
      });
      if (response.success) {
        const { result, success } = response.result;
        if (success) {
          if (isUpdate) {
            successCbk(result);
          } else {
            yield put({ type: YELP_SUCCESS, yelpInfo: result });
          }
        } else {
          yield put({ type: YELP_FAILURE });
        }
      }
    } catch (error) {
      console.log('Saga: yelpLinkFlow:', error);
    }
  }
}

export function* googlePlaceIdFlow() {
  while (true) {
    const request = yield take(GOOGLE_REVIEW_REQUEST);
    try {
      let response;
      const { payload, successCbk = () => { }, isUpdate = false } = request;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/google_place_reviews/${payload}`)
      });
      if (response.success) {
        const { result, success } = response.result;
        if (success) {
          if (isUpdate) {
            successCbk(result);
          } else {
            yield put({ type: GOOGLE_REVIEW_SUCCESS, googlePlaceIdInfo: result, placeId: request.payload });
          }
        } else {
          yield put({ type: GOOGLE_REVIEW_FAILURE });
        }
      }
    } catch (error) {
      console.log('Saga: googlePlaceIdFlow:', error);
    }
  }
}

export function* getStateList() {
  while (true) {
    const request = yield take(SATE_LIST_REQUEST);
    try {
      let response;
      const { country } = request.payload;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/country_regions/${country}`)
      });
      if (response.success) {
        if (response.result !== []) {
          yield put({ type: SATE_LIST_SUCCESS, stateList: response.result });
        } else {
          yield put({ type: SATE_LIST_FAILURE, stateList: [] });
        }
      }
    } catch (error) {
      console.log('Saga: getStateList:', error);
    }
  }
}

export function* getCompanyList() {
  while (true) {
    const request = yield take(COMPANY_LIST_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`admin/company_search?term=${request.payload}`)
      });
      if (response.success) {
        if (response.result !== []) {
          yield put({ type: COMPANY_LIST_SUCCESS, companyList: response.result });
        } else {
          yield put({ type: COMPANY_LIST_FAILURE, companyList: [] });
        }
      }
    } catch (error) {
      console.log('Saga: getCompanyList:', error);
    }
  }
}

export function* deleteCompanyLogo() {
  while (true) {
    const request = yield take(DELETE_COMPANY_LOGO_REQUEST);
    const { companyId, successCbk, failureCbk } = request.payload;
    try {
      let response;
      response = yield call(deleteMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/logo`)
      });
      if (response.success) {
        successCbk();
      } else {
        failureCbk();
      }
    } catch (error) {
      failureCbk();
      console.log('Saga: deleteCompanyLogo :', error);
    }
  }
}

export function* updateCompanyLogo() {
  while (true) {
    const request = yield take(UPDATE_COMPANY_LOGO_REQUEST);
    const { imageName, imageObj, successCbk, failureCbk, companyId } = request.payload;

    try {
      var formData = new FormData();
      formData.append('company[logo_img]', imageObj, imageName);
      var requestOptions = {
        method: 'PUT',
        body: formData,
        headers: {
          Authorization: getToken(),
          Accept: 'application/json',
        }
      };

      fetch(settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/logo`), requestOptions).then(function (data) {
        const { status } = data;
        if (status === 200) {
          successCbk();
        } else {
          failureCbk();
        }
      });
    } catch (error) {
      failureCbk();
    }
  }
}

export function* updateRatingDetails() {
  while (true) {
    const request = yield take(UPDATE_RATING_REQUEST);
    const { body, companyId, successCbk = () => { }, failureCbk = () => { } } = request.payload;
    try {
      let response;
      response = yield call(putMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}`),
        body
      });
      const { success, result } = response;
      if (success && result.success) {
        const { company_info, company, eligible_for_ein } = response.result;
        const country = lodashGet(company, `address.country`);
        const belongsToList = getBelongsTo(country);
        yield put({ type: UPDATE_RATING_SUCCESS });
        yield put({
          type: UPDATE_ACCOUNT_MANAGER_SUCCESS,
          companyInfo: company_info,
          company,
          eligibleForEin: eligible_for_ein,
          countryCode: country,
          ...belongsToList
        });
        successCbk();
      } else {
        yield put({ type: UPDATE_RATING_FAILURE });
        failureCbk();
      }
    } catch (error) {
      console.log('Saga: updateRatingDetails:', error);
      yield put({ type: UPDATE_RATING_FAILURE });
      failureCbk();
    }
  }
}
